<!-- <ui-figure-caption>
  <ui-figure-number>Tabell 5.</ui-figure-number>
  <ui-figure-text>I rapporten förekommer en hel del begrepp som förklaras och preciseras i denna tabell.

  </ui-figure-text>
</ui-figure-caption> -->
<app-ui-table [tableConfig]="tableConfig" [tableContent]="tableContent">
</app-ui-table>
